import React from 'react'
import { Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import { DisplayStackTrace } from 'components/molecules/errorBoundary'
import QAPVars from 'qap/vars'

import { Theme } from '@mui/material/styles'
import type { ErrorComponentInterface } from 'components/molecules/errorBoundary'

const styles = (theme: Theme) => ({
  root: {
    padding: theme.spacing(5),
    fontFamily: theme.typography.mediumFontFamily
  },

  link: {
    color: QAPVars.linkBlue,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
})

const GlobalErrorBoundary = ({
  classes,
// @ts-expect-error - TS2339 - Property 'host' does not exist on type 'ErrorComponentInterface'.
  host,
  errors,
}: ErrorComponentInterface) => {
  let title = 'Something has gone wrong'
  let description = (
    <div>
      The development team has been notified of the issue.
      Try <a href='.' className={classes.link}>refreshing the page</a>.
    </div>
  )

// @ts-expect-error - TS18047 - 'errors' is possibly 'null'.
  if (errors.name === 'ChunkLoadError') {
    setTimeout(() => window.location.reload(), 2000)

    title = 'An Update is Available'
    description = (
      <div>
        A new version of myQAP has been released.
        Please <a href='.' className={classes.link}>refresh the page</a>.
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Typography variant='h1'>{title}</Typography>
      {description}

{ /* @ts-expect-error - TS2322 - Type '{ host: any; errors: (Error & ErrorStack) | null; }' is not assignable to type 'IntrinsicAttributes & Omit<{ classes: any; } & Errors, "classes"> & StyledComponentProps<"errors" | "root"> & object'. */}
      <DisplayStackTrace host={host} errors={errors} />
    </div>
  )
}

export default withStyles(styles)(GlobalErrorBoundary)
